// import _Loading from 'assets/scripts/_app/cuchillo/layout/Loading';

export default class Loading /*extends _Loading*/ {
  static start() { }
  static stop() { }
}


